import { computed } from 'vue'
import type { ComputedRef, Ref } from 'vue'
// types
import type { StrapiFooter, StrapiSingleResponse } from '@ts-strapi/interfaces'
// hooks
import { useStrapiFetch } from '@api/strapi/use-strapi-fetch.hook'

interface UseStrapiFooterReturn {
  refFooter: ComputedRef<StrapiFooter | null>
  refPending: Ref<boolean>
  refError: Ref<Error | null>
  refresh: () => Promise<void>
}

export const useStrapiFooter = async (): Promise<UseStrapiFooterReturn> => {
  const strapiFetch = useStrapiFetch()

  const { data, pending, error, refresh } = await useAsyncData(
    'strapi:footer',
    () => strapiFetch<StrapiSingleResponse<StrapiFooter>>('/footer', {
      params: {
        'populate[columns][populate][links]': 'true',
        'populate[socials]': 'true',
        'populate[paymentBadges][populate][image]': 'true',
        'populate[trustBadges][populate][image]': 'true',
        'populate[bottomItems]': 'true',
      },
    }),
  )

  return {
    refFooter: computed(() => data.value?.data ?? null),
    refPending: pending,
    refError: error as Ref<Error | null>,
    refresh: () => refresh(),
  }
}
